import { FC } from 'react';
import logo from './intervlag_logo.png';

import './Header.scss';

const Header: FC = () => {
  return (
    <header className="app-header">
      <img src={logo} className="app-header__logo" alt="logo" />
    </header>
  );
};

export default Header;
